import { useQuery } from '@tanstack/react-query';
import { fetchActs } from '@/api/plan';
import { tripKeys } from '@/api/queryKeys';

export function useActs(slug: string) {
  return useQuery({
    queryKey: tripKeys.acts(slug),
    queryFn: ({ signal }) => fetchActs(slug, signal).then((r) => r.acts),
    staleTime: 60_000,
  });
}
